import React from "react";

const LOGO_SRC = "/logo.png";

export function Logo({
  className = "h-8 lg:h-10 w-auto",
  inverted = false,
  width = 120,
  height = 40,
}) {
  return (
    <img
      src={LOGO_SRC}
      alt="Creativorare"
      className={`${className}${inverted ? " brightness-0 invert" : ""}`}
      width={width}
      height={height}
      loading="eager"
      decoding="async"
      fetchPriority="high"
    />
  );
}
